/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-enable import/no-unresolved, import/default */

import './attribute-dialog-edit-json.scss';

/*@ngInject*/
export default function AttributeDialogEditJsonController($mdDialog, types, jsonValue, readOnly) {

    let vm = this;
    vm.json = angular.toJson(jsonValue, 4);
    vm.readOnly = readOnly;
    vm.contentType = types.contentType.JSON.value;

    vm.save = () => {
        $mdDialog.hide(angular.fromJson(vm.json));
    };

    vm.cancel = () => {
        $mdDialog.cancel();
    };
}
